
const prodConf = {
  // baseApiUrl: 'https://api.megaphon.co.il/api/',
  // baseApiUrl: 'api/',
  baseServerUrl: location.origin,
  // baseApiUrl: location.origin + '/api',
}

module.exports = prodConf;